import Model, { attr } from '@ember-data/model';

export default class KineticMaterialBase extends Model {
  @attr('number') sequence;
  @attr('string') partNumber;
  @attr('string') partDescription;
  @attr('number') relatedOperation;
  @attr('number') quantityPer;
  @attr('boolean', { defaultValue: false }) fixedQuantity;
  @attr('boolean', { defaultValue: false }) serialTracked;
  @attr('boolean', { defaultValue: false }) lotTracked;
}
